<div class="appContent" fxLayout="column">
  
  
    <!-- <app-map fxFlex> </app-map> -->
    <app-baladya-map fxFlex></app-baladya-map>

    
    <div style="display: none;">
      <div id="ctr">
        <app-sequential-search ></app-sequential-search>
        
      </div>
      
    </div>
  </div>
  <div class="dashContent" >
    <app-inner-dashboard > </app-inner-dashboard>

  </div>
  <div class="bottom-dashboard">
    <app-dashboard></app-dashboard>
  </div>